import { createStore, combineReducers, compose, applyMiddleware } from 'redux';
import createHistoryEnhancer from 'farce/lib/createHistoryEnhancer';
import BrowserProtocol from 'farce/lib/BrowserProtocol';
import queryMiddleware from 'farce/lib/queryMiddleware';
import createMatchEnhancer from 'found/lib/createMatchEnhancer';
import Matcher from 'found/lib/Matcher';

import { keaReducer, activatePlugin } from 'kea';
import foundReducer from 'found/lib/foundReducer';
import thunkPlugin from 'kea-thunk';
import thunk from 'redux-thunk';

import routes from '../../routes/Routes';
import cart from '../../components/_common/Cart/CartReducer';

activatePlugin(thunkPlugin);

const checkoutReducer = keaReducer('checkout');
const layoutReducer = keaReducer('layout');
export const reducers = combineReducers({
  cart,
  checkout: checkoutReducer,
  layout: layoutReducer,
  found: foundReducer,
});

const finalCreateStore = compose(
  createHistoryEnhancer({
    protocol: new BrowserProtocol(),
    middlewares: [queryMiddleware],
  }),
  createMatchEnhancer(new Matcher(routes)),
  applyMiddleware(thunk),
)(createStore);

export default finalCreateStore(reducers);
